import React from 'react';
import { Box, Heading, Text, OrderedList, ListItem, Button, UnorderedList} from '@chakra-ui/react';
import ApplicationFAQ from './ApplicationFAQ';
import './fonts/fonts.css';

const ApplicationInfo = () => {
    return (
        <Box
        bg="#FFFFEA"
        borderRadius={{ base: "10px", lg: "20px" }}
        width={{ base: "90%", lg: "94%", "2xl": "90%" }}
        height={{ base: "40%", lg: "80%", "2xl": "90%" }}
        overflow="hidden"
        position="relative"
        py="3%" // Consolidated padding-top and padding-bottom
        >
            <Box p={"5%"}>
                <Heading
                fontSize={{ base: "4vw", lg: "4vw", "2xl": "4vw" }}
                color="black"
                opacity="90%"
                fontFamily="Nohemi"
                align={"center"}
                >
                    2026 CYLC Application Process
                </Heading>
                <Text
                align={"center"}
                fontSize={{ base: "2.3vw", lg: "1.5vw", "2xl": "1vw" }}
                pb={"3%"}
                fontFamily={"NohemiLight"}
                >
                    Welcome to 2026 CYLC! You may always refer to the Application Q&A for additional information.
                </Text>
                <Heading
                fontSize={{ base: "2.3vw", lg: "2vw", "2xl": "2vw" }}
                fontFamily={"Nohemi"}
                >
                    Important Dates and Deadlines
                </Heading>
                <UnorderedList as="ul" fontSize={{base: "2vw", lg:"1.5vw", "2xl": "1vw"}} p={"2%"} fontFamily={"NohemiLight"}>
                    <ListItem>
                        Applications Begin: Monday, January 12, 2026, 8:00PM CT
                    </ListItem>
                    <ListItem>
                        Application Deadline: Friday, February 6, 2026
                    </ListItem>
                    <ListItem>
                        C/AC Application Deadline (Resume, Essay): Friday, February 13, 2026
                    </ListItem>
                    <ListItem>
                        C/AC Interviews: March 7-8, 2026
                    </ListItem>
                    <ListItem>
                        Notification of C/AC Acceptance: March 7-8, 2026
                    </ListItem>
                    <ListItem>
                        T/TA Application Deadline: Sunday, March 15, 2026
                    </ListItem>
                    <ListItem>
                        C/AC Meet and Greet: Saturday, March 28, 2026
                    </ListItem>
                    <ListItem>
                        C/AC Trainings:
                        <OrderedList as="ol" fontSize={{base: "2vw", lg:"1.5vw", "2xl": "1vw"}} p={"2%"} styleType={"lower-alpha"}>
                            <ListItem>
                                June 20, 2026 - June 21, 2026
                            </ListItem>
                            <ListItem>
                                June 27, 2026 - June 28, 2026
                            </ListItem>
                            <ListItem>
                                July 11, 2026 - July 12, 2026 (weekend Mandatory--must let us know by meet and greet if intending to miss morning of 7/11 for ACT as that is the only excusable absence)
                            </ListItem>
                            <ListItem>
                                July 19, 2026 (Mandatory)
                            </ListItem>
                            <ListItem>
                                Maximum miss 2 trainings.
                            </ListItem>
                        </OrderedList>
                    </ListItem>
                    <ListItem>
                        CYLC 2026: July 20, 2026 - July 25, 2026
                    </ListItem>
                    <ListItem>
                        Camp Reunion: August 1, 2026 (Tentative, will be confirmed)
                    </ListItem>
                </UnorderedList>
                <Heading
                fontSize={{ base: "2.3vw", lg: "2vw", "2xl": "2vw" }}
                fontFamily={"Nohemi"}
                >
                    Application (Opens Monday, 1/12/2026, 8:00 PM) -- only one application that will need to be filled out. Campers are accepted on a first come, first served basis.
                </Heading>
                <OrderedList as="ol" fontSize={{base: "2vw", lg:"1.5vw", "2xl": "1vw"}} p={"2%"} fontFamily={"NohemiLight"}>
                    <ListItem>
                        Fill out the Google Form, linked on the Application tab of the website. Please use the parent’s email address for the primary email.
                    </ListItem>
                    <ListItem>
                        Fill out the request information accurately. Print/complete/scan the waiver forms back into the Google Form as needed.
                        <UnorderedList>
                            <ListItem>
                                A complete Application should include:
                            </ListItem>
                            <ListItem>
                                Google Form responses for camper and parent information
                            </ListItem>
                            <ListItem>
                                Copy of the camper’s Health Insurance
                            </ListItem>
                            <ListItem>
                                <a
                                    href="/assets/1--2026 TAMU Waiver form 1 Indemnification-and-Medical-Treatment-Authorization.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    East Texas A&M Agreement for Waiver, Indemnification, Assumption of Risk and Medical Treatment Authorization Scan
                                </a>
                            </ListItem>
                            <ListItem>
                                <a
                                    href="/assets/2--2026 TAMU Waiver form 2 MRC Waiver.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    East Texas A&M MRC Recreation Form Waiver
                                </a>
                            </ListItem>
                            <ListItem>
                                <a
                                    href="/assets/3--2026 minormedicalform.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    East Texas A&M Medical Release Form
                                </a>
                            </ListItem>
                            <ListItem>
                                <a
                                    href="/assets/4--2026 CYLC Medical Release and Activity Permission Slip.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                    }}
                                >
                                    CYLC Medical Release Form/Activity Permission Slip Waiver Scan
                                </a>
                            </ListItem>
                            <ListItem>
                                Camp fee check $750 (check payable to CYLC and mailed via physical mail. Write camper name and current grade level on the check in the memo section. This will be the only thing that is mailed)
                            </ListItem>
                        </UnorderedList>
                    </ListItem>
                    <ListItem>
                        Mail the check to “CYLC, P.O. Box 868156, Plano, TX 75086.” Postmarked by Friday 2/6/26
                    </ListItem>
                    <ListItem>
                        After you submit Google Form, a copy of your responses will be sent to your email. Please save this for your own records.
                    </ListItem>
                    <ListItem>
                        After receiving the camp fee check, CYLC (cylcdfw@gmail.com) will send an email notifying of a completed application and acceptance of your camper.
                    </ListItem>
                    <ListItem>
                        CYLC will take the first 400 complete applications on a first come, first served basis.
                    </ListItem>
                </OrderedList>
                <Box display="flex" justifyContent={"center"} p={"4%"}>
                    <Button as="a" w={"60%"} h={"5vw"} bg={"#FFED68"} borderRadius={"20px"} fontSize={{base: "2vw", lg:"4w", "2xl": "2vw"}} p={"1%"} fontFamily={"NohemiLight"} href="https://forms.gle/xAgMvzPzYEuZbUqB6" target="_blank">
                        Link to Camper Application
                    </Button>
                </Box>
                <Text
                fontSize={{ base: "2.3vw", lg: "1.5vw", "2xl": "1.3vw" }}
                style={{color: "#FF716E"}}
                fontFamily={"Nohemi"}
                align={"center"}
                >
                    NOTE: An applicant must complete the camper application and the C/AC application to qualify for an interview.
                </Text>
                <Box display="flex" justifyContent={"center"} p={"4%"}>
                    <Button as="a" w={"60%"} h={"5vw"} bg={"#FFED68"} borderRadius={"20px"} fontSize={{base: "2vw", lg:"4w", "2xl": "2vw"}} p={"1%"} fontFamily={"NohemiLight"} href="https://forms.gle/sjLnDLW8orgoUpqY7" target="_blank">
                        Link to C/AC Application
                    </Button>
                </Box>
                <ApplicationFAQ />
                <Text
                fontSize={{ base: "2.3vw", lg: "1.5vw", "2xl": "1.3vw" }}
                style={{color: "#FF716E"}}
                fontFamily={"Nohemi"}
                >
                    NOTE: The dates and training location may be changed subject to availability - CYLC will notify C/ACs by email in the event of any changes. Each C/AC team will need to do some additional work outside of the three training weekends. It is very important for C/ACs to commit to the training schedule so that we can be prepared for camp.
                </Text>
                <Heading
                fontSize={{ base: "2.3vw", lg: "2vw", "2xl": "2vw" }}
                mt={"2%"}
                fontFamily={"Nohemi"}
                >
                    *For any other questions, please email cylcdfw@gmail.com
                </Heading>
            </Box>
        </Box>
    );
};

export default ApplicationInfo;